import React from 'react';
import ModalWrap from '@/src/component/_form/ModalWrap';
import TrialDetail from './TrialDetail';

export default class TrialIndex extends React.Component {
	constructor (props) {
		super(props);
		this.state= {
      modalDetail: {
        status: 'init',
        current: null
        // status: true,
        // current: null
      }
    }
	}

	checkLog= ( modalDetail, data )=> {
    if( !this.props.logInfo ) {
      alert('로그인이 필요합니다.')
      this.props.IndexClass.routing.routing('/login');
    } else this.handlerModalOpen(modalDetail, data);
  }

  handlerModalOpen= (key, val, e)=> {
    this.setState({
      [key] : {
        status: true,
        current: val
      }
    });
  }
  
  handlerModalClose= (key, val, e)=> {
    this.setState({
      [key] : {
        status: false,
        current: null
      }
    });
  }

	render () {
	
		
		return (
			<>
			<ModalWrap
        modalDetail={this.state.modalDetail.status}
      >
        <TrialDetail
          offModal={this.handlerModalClose}
          datas={this.state.modalDetail.current}
          IndexClass={this.props.IndexClass}
          logInfo={this.props.logInfo}
        />
      </ModalWrap>
      
      {
        this.props.children && 
        React.cloneElement(this.props.children, { handler: this.checkLog.bind(null, 'modalDetail') })
      }
      
      {
        !this.props.children &&
        <div className="trial-btn-sect">
          <button 
            onClick={this.checkLog.bind(null, 'modalDetail')}
            className="bg-clr-4 ft2 ft-wh ft-b lh-10 pd-s20 pd-h10 bd-rd-10">
            무료 체험판 신청하기
          </button>
        </div>
      }
			
			</>
		)
	}

}